<template>
  <div id="spin-calendar-view-wrapper">
    <div id="spin-calendar-wrapper">
      <calendar-component
        :events="events"
        id="spin-calendar-view-calendar"
        @month-change="monthChange"
        @year-change="yearChange"
      />
      <p>
        Subscribe to calendar with the following link: <br />
        <a>{{ link }}</a>
      </p>
    </div>
    <base-card
      id="spin-calendar-upcoming-events"
      :scrollable="displayArt ? false : true"
    >
      <img v-if="displayArt" :src="notFoundArt" alt="No events this month" />
      <contact-location-event-details
        v-for="(event, index) in eventsInTimeFrame"
        :key="index"
        :event="event"
      />
    </base-card>
  </div>
</template>
<script>
import BaseCard from "../Components/UI/BaseCard.vue";
import CalendarComponent from "../Components/Calendar/CalendarComponent.vue";

import ContactLocationEventDetails from "../Components/UI/ListItems/Event/ContactLocationEventDetails.vue";

export default {
  data() {
    return {
      notFoundArt: require("../Components/UI/Illustrations/MarsDJNoEventsHere.png"),
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
    };
  },
  computed: {
    link() {
      return `https://api.spindj.io/calendar/thislinkworkswithaliveaccount`;
    },
    events() {
      return this.$store.getters.events().sort((a, b) => {
        let startTime = (event) => {
          switch (event.api_version) {
            case "9-28-2022":
              return new Date(event.start_time).getTime();
            default:
              return new Date(event.data.startTime).getTime();
          }
        };
        let aStart = startTime(a);
        let bStart = startTime(b);
        return aStart < bStart ? -1 : aStart > bStart ? 1 : 0;
      });
    },
    eventsInTimeFrame() {
      return this.events.filter((x) => {
        let startTime = (event) => {
          switch (event.api_version) {
            case "9-28-2022":
              return new Date(event.start_time);
            default:
              return new Date(event.data.startTime);
          }
        };
        let date = new Date(this.year, this.month);
        return (
          startTime(x).getMonth() === date.getMonth() &&
          startTime(x).getFullYear() === date.getFullYear()
        );
      });
    },
    displayArt() {
      return this.eventsInTimeFrame.length === 0;
    },
  },
  methods: {
    monthChange(month) {
      this.month = month;
    },
    yearChange(year) {
      this.year = year;
    },
  },
  components: { CalendarComponent, BaseCard, ContactLocationEventDetails },
  props: [],
};
</script>
<style scoped>
@media screen {
  #spin-calendar-view-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  #spin-calendar-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  #spin-calendar-wrapper > p {
    font-size: 0.75rem;
    margin: 25px;
  }

  a {
    cursor: pointer;
    font-weight: 600;
  }

  #spin-calendar-view-calendar {
    max-height: 500px;
    min-height: 450px;
    height: fit-content;
  }

  #spin-calendar-upcoming-events {
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  img {
    max-width: 100%;
    height: 100%;
    object-fit: contain;
    margin: auto;
  }
  @media (min-width: 800px) {
    #spin-calendar-view-wrapper {
      height: 100%;
      min-height: calc(100vh - 150px);
      max-height: calc(100vh - 150px);
      width: calc(100% + 50px);
      flex-direction: row;
    }

    #spin-calendar-wrapper {
      flex: 1 1 auto;
    }

    #spin-calendar-view-calendar {
      min-height: 450px;
      width: 400px;
    }
    p {
      margin: 50px;
    }

    #spin-calendar-upcoming-events {
      flex: 1 0 auto;
      width: 500px;
      height: 500px;
      margin-right: 10px;
    }
  }
}
</style>
